import React,{useState} from 'react';
import {Redirect} from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Title from './Title';
import Loading from './Loading';
import Toast from './Toast';
import {SiteName} from './Inc';
import {UserContainer} from './UserContainer';

interface Props {
    mode?:string
}

const Login = (props:Props)=> {
    const [states,setStates] = useState({
        email:"",
        isSend:false,
        isLoading:false,
    })
    const [isFinished,setIsFinished] = useState(false);
    const [toast,setToast] = useState("");
    const userState = UserContainer.useContainer();
    const signInWithGoogle = ()=>{
        setStates({...states,isLoading:true});
        userState.signIn( "google",()=>{
            setIsFinished(true);
        },()=>{
			setStates({...states,isLoading:false});
            setToast("ログインできませんでした");
		});
    }
    const signInWithTwitter = ()=>{
        setStates({...states,isLoading:true});
        userState.signIn( "twitter",()=>{
            setIsFinished(true);
        },()=>{
			setStates({...states,isLoading:false});
            setToast("ログインできませんでした");
		});
    }
    const signInWithEmail = ()=>{
        setStates({...states,isLoading:true});
        const email = states.email;
        userState.sendEmail(email,()=>{
            setStates({...states,isLoading:false,isSend:true});
        },()=>{
			setStates({...states,isLoading:false});
            setToast("メールの送信に失敗しました");
        });      
    }

    const validateEmail = ()=>{
        let error = "";
        if( states.email==="" ){
            error = "メールアドレスを入力してください";
        } else if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(states.email)){
            error = "メールアドレスが正しくありません";
        }
        if( error!=="" ){
            setToast(error);
        } else {
            signInWithEmail();
        }
    }
    const changeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStates({...states,"email":event.target.value});
    }
    const closeToast = ()=>{
        setToast("");
    }

    if( isFinished ){
		return (
			<Redirect to="/"/>
		)
    }
  
    if( !userState.ready ){
        return (null);
    }

	document.title = "ログイン｜"+SiteName;

    return (
        <div id="login" className="miniRoot">
            <Paper className="paper">
                <Title size={3} text={"ログイン"} icon={"user-circle"}></Title>
            {!states.isSend ? (
                <div>
                    <div className="talk">
                        このサービスをご利用いただくには、ＳＮＳのアカウントが必要です。
                    </div>
                {userState.user &&
                    <FormControl fullWidth={true}>
                        <Button variant="contained" color="primary" onClick={userState.logout}>ログアウト</Button>
                    </FormControl>
                }
                {!userState.user &&
                    <React.Fragment>
                    <FormControl fullWidth={true} style={{marginBottom:"0.5em"}}>
                        <Button variant="contained" color="default" onClick={signInWithTwitter}>
                            <FontAwesomeIcon icon={['fab','twitter']} style={{marginRight:"0.5em"}}/>Twitter
                        </Button>
                    </FormControl>
                    <FormControl fullWidth={true}>
                        <Button variant="contained" color="default" onClick={signInWithGoogle}>
                            <FontAwesomeIcon icon={['fab','google']} style={{marginRight:"0.5em"}}/>Google
                        </Button>
                    </FormControl>

                    <div className="mailLoginInput">
                        <FormControl fullWidth={true}>
                            <TextField
                                id="email"
                                value={states.email}
                                onChange={changeEmail}
                                margin="dense"
                                placeholder="メールアドレス"
                                //variant="outlined"
                            />
                        </FormControl>
                        
                        <FormControl fullWidth={true}>
                            <Button variant="contained" color="default" onClick={validateEmail}>
                                <FontAwesomeIcon icon="envelope" style={{marginRight:"0.5em"}}/>メールでログイン
                            </Button>
                        </FormControl>
                    </div>


                    </React.Fragment>
                }
                </div>
            ):(
                <div className="talk">
                    <p>{states.email}にメールを送信いたしましたのでご確認ください。</p>
                    <p>メールに書かれたURLは1回限り有効です。</p>
                </div>
            )}

            </Paper>
            <Toast mes={toast} close={closeToast}/>
            <Loading isLoading={states.isLoading}/>
        </div>
    );
}

export default Login;
